import React from "react";
import { useState, useEffect } from "react";
import SwitchBox from "./SwitchBox";

const TableRow = ({ item, index, handleDelete, isOnDescription, isTranslateAll }) => {

    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => setExpanded(!expanded);
    const [checked, setChecked] = useState(false); 

    const handleToggle = () => {
      setChecked((prev) => !prev); 
    };

    async function translateText(text, targetLang) {
      const response = await fetch('https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=' + targetLang + '&dt=t&q=' + encodeURIComponent(text));
      const result = await response.json();
      return result[0].map(item => item[0]).join('');
    }

    useEffect(() =>{
      setChecked(isTranslateAll);
    }, [isTranslateAll])

    const [translatedText, setTranslatedText] = useState(item?.description || "");


    useEffect(() => {
      const description = item?.description || "";
  
      if (checked) {
        translateText(description, "vi").then(setTranslatedText);
      } else {
        setTranslatedText(description);
      }
    }, [checked, item?.description]);
    
    const [showAllCommentsLow, setShowAllCommentsLow] = useState(false);
    const commentsToShow = item.lowToFourStars?.length ? (showAllCommentsLow ? item.lowToFourStars : item.lowToFourStars.slice(0, 4)) : [];
  

    const [showAllCommentsFiveStar, setShowAllCommentsFiveStar] = useState(false);
    const commentsToShowFiveStar =  item.fiveStars?.length ? (showAllCommentsFiveStar ? item.fiveStars : item.fiveStars.slice(0, 4)) : [];

    return (
    <React.Fragment key={item.app_id || index}>
      {/* Dòng chính */}
      <tr className="even:bg-gray-100 hover:bg-gray-200 transition">
        <td className="p-3 border border-gray-300 text-center">{index + 1}</td>
        <td className="p-3 border border-gray-300 text-center">
          <img src={item.icon_url} alt="icon" className="w-10 h-10 mx-auto rounded-md shadow-md" />
        </td>
        <td className="p-3 border border-gray-300 text-center">{item.name}</td>
        <td className="p-3 border border-gray-300 text-center break-words max-w-xs">{item.app_id}</td>
        <td className="p-3 border border-gray-300 text-center">{item.release_date}</td>
        <td className="p-3 border border-gray-300 text-center">{item.update_date}</td>
        <td className="p-3 border border-gray-300 text-center">{item.installs}</td>
        <td className="p-3 border border-gray-300 text-center">{item.revenue}</td>
        <td className="p-3 border border-gray-300 text-center">{item.download}</td>
        <td className="p-3 border border-gray-300 text-center">
          <a href={item.link} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">
            CHPlay
          </a>
        </td>
        <td className="p-3 border border-gray-300 text-center">
          <a href={item.linkSensor} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">
            Sensortower
          </a>
        </td>
        <td className="p-3 border border-gray-300 text-center">
          <a href={item.linkAppBrain} className="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">
            AppBrain
          </a>
        </td>
        <td
          className="p-3 border border-gray-300 text-center text-red-600 hover:underline cursor-pointer"
          onClick={() => handleDelete(item.app_id)}
        >
          Xóa
        </td>
      </tr>
      
      {/* Dòng mở rộng */}
      {isOnDescription && (
        <tr className="bg-gray-50">
          <td colSpan="4" className="align-top relative break-words">
          {/* SwitchBox ở góc trên bên phải */}
          <div className="absolute top-1 right-1">
            <SwitchBox checked={checked} onChange={handleToggle} />
          </div>

          <div className="w-auto break-words whitespace-pre-wrap">
            <p
              dangerouslySetInnerHTML={{
                __html: expanded
                  ? translatedText
                  : translatedText.length > 600
                  ? translatedText.substring(0, 600) + "..."
                  : translatedText,
              }}
            />
          </div>

          {translatedText.length > 600 && (
            <button
              onClick={toggleExpand}
              className="text-blue-500 hover:underline ml-2"
            >
              {expanded ? "Thu gọn" : "Xem tiếp"}
            </button>
          )}
        </td>

      <td colSpan="2" className="border border-gray-300 p-2 align-top">
        {item.lowToFourStars && item.lowToFourStars.length > 0 ? (
          <>
            {commentsToShow.map((comment, index) => (
              <div key={index}>
                {comment.score}⭐ - {comment.date}: <span className="text-sm">{comment.text}</span>
              </div>
            ))}

            {/* Nếu có hơn 4 comment, hiển thị nút "Xem thêm / Thu gọn" */}
            {item.lowToFourStars.length > 4 && (
              <button
                onClick={() => setShowAllCommentsLow(!showAllCommentsLow)}
                className="text-blue-500 mt-2 cursor-pointer hover:underline"
              >
                {showAllCommentsLow ? "Thu gọn" : "Xem thêm"}
              </button>
            )}
          </>
        ) : (
          <div>Không có dữ liệu</div>
        )}
      </td>

      <td colSpan="2" className="border border-gray-300 p-2 align-top">
        {item.fiveStars && item.fiveStars.length > 0 ? (
          <>
            {commentsToShowFiveStar.map((comment, index) => (
              <div key={index}>
                {comment.score}⭐ - {comment.date}: <span className="text-sm">{comment.text}</span>
              </div>
            ))}

            {/* Nếu có hơn 4 comment, hiển thị nút "Xem thêm / Thu gọn" */}
            {item.fiveStars.length > 4 && (
              <button
                onClick={() => setShowAllCommentsFiveStar(!showAllCommentsFiveStar)}
                className="text-blue-500 mt-2 cursor-pointer hover:underline"
              >
                {showAllCommentsFiveStar ? "Thu gọn" : "Xem thêm"}
              </button>
            )}
          </>
        ) : (
          <div>Không có dữ liệu</div>
        )}
      </td>

        <td colSpan="5" className="p-4 border border-gray-300">
          <div className="space-y-2 flex justify-start">
            {item.screenshots && item.screenshots.length > 0 ? (
              <div className="origin-top-left transform">
                <div className="flex gap-2 flex-wrap">
                  {item.screenshots.map((img, index) => (
                    <div key={index} className="w-fit">
                      <img
                        src={img.src}
                        alt={`screenshot-${index}`}
                        className="rounded-lg shadow-md w-[100px]"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <p className="text-gray-500 text-center">Không có ảnh</p>
            )}
          </div>
        </td>
      </tr>
    )}
      
    </React.Fragment>
  );
};

export default TableRow;
